import { useState } from "react";
import { useTranslations } from "next-intl";
import { Button } from "../../core";

const LoadMoreClosets = ({
  loadNextPage, allLoaded, prevClosets,
}) => {
  const t = useTranslations("closets");

  const [loading, setLoading] = useState(false);

  async function loadClosets() {
    if (loading) return;

    try {
      setLoading(true);
      await loadNextPage();
    } finally {
      setLoading(false);
    }
  }

  if (prevClosets.length < 1) return null;

  return (
    <div className="col-12 mt-4 mb-4 text-center">
      {allLoaded ? (
        <p>{t("no_more_closet")}</p>
      ) : (
        <div className="mx-auto">
          <Button
            className="btn-dark"
            loading={loading}
            onClick={() => loadClosets()}
          >
            {t("load_more_closets")}
          </Button>
        </div>
      )}
    </div>
  );
};

export default LoadMoreClosets;
